<template>
  <div>
    <p class="cm-mg-p-wzd">
      {{ $t('common_words.general_id_information') }}
    </p>
    <hr />
    <br />
    <div class="row">
      <div class="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('common_words.select_companies') }} *</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select bus-rels shadow-sm"
            size="large"
            v-model="model.businesses_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
            multiple
            collapse-tags
            @change="selectAllFromSelect('model.businesses_id', businesses)"
          >
            <el-option
              v-for="option in businesses"
              class="select-primary selected-all"
              :value="option.id"
              :label="option.name"
              :key="option.name"
            ></el-option>
          </el-select>
        </div>
      </div>
      <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <label>{{ $t('common_words.starting_date') }} *</label>
        <el-date-picker
          v-if="renderComponent"
          class="required-date"
          v-model="model.date"
          type="date"
          :placeholder="$t('common_words.date_pick')"
        >
        </el-date-picker>
      </div>
      <div class="col-sm-6 col-md-4 col-lg-4 col-xl-4">
        <div class="form-group has-label">
          <label class="text-transform-none"
            >{{ $t('calibration.select_hands_type') }} *</label
          >
          <br />
          <el-select
            clearable
            class="select-primary custom-width-select shadow-sm calibration-type"
            size="large"
            v-model="model.calibration_type_id"
            :placeholder="`${$t('common_words.select')}...`"
            filterable
          >
            <el-option
              v-for="option in calibration_types"
              class="select-primary"
              :value="option.id"
              :label="option.name"
              :key="option.id"
            ></el-option>
          </el-select>
        </div>
      </div>
    </div>

    <div class="row" v-show="errorAlert">
      <div class="col-lg-12">
        <br />
        <el-alert
          ref="error_alert"
          :title="$t('common_words.errors')"
          type="error"
          >{{ error }}</el-alert
        >
      </div>
    </div>
  </div>
</template>

<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import mixinMasters from 'src/util/mixinMasters';
import MixinPermissions from 'src/util/mixinPermissions';
import moment from 'moment';

export default {
  data() {
    return {
      model: {
        businesses_id: null,
        date: null,
        calibration_type_id: null,
      },
      businesses: null,
      calibration_types: [],
    };
  },

  mixins: [mixinMasters, MixinPermissions],

  watch: {
    '$i18n.locale': ['forceRerender', 'getSelectAll'],
  },

  methods: {
    getSelectAll() {
      this.businesses = this.concatAll(this.businesses.splice(1));
    },
    validate() {
      return this.$validator
        .validateAll()
        .then((res) => {
          this.$emit('on-validated', res, this.model);
          let others = [];
          this.$emit('fillrangeCalibrationForm', 'firstStep', {
            names_business: others,
          });
          return res;
        })
        .then((resp) => {
          if (!resp) return resp;

          if (this.model.businesses_id.length == 0) {
            this.highlightItem('bus-rels');

            return false;
          } else if (this.model.date == null) {
            return this.validationInputsRequired('date');
          } else if (!isset(this.model.calibration_type_id)) {
            this.highlightItem('calibration-type');

            return false;
          } else {
            return true;
          }
        });
    },
  },
  mounted() {
    if (this.isCreate() || this.isUpdate()) {
      this.showHideLoading(true);
      Promise.all([
        Axios.getMasters('businesses/only'),
        Axios.getMasters('calibration/calibrationtypes'),
      ])
        .then(([responseBusinesses, responseCalibrations]) => {
          this.businesses = this.concatAll(responseBusinesses.data.data);
          this.calibration_types = responseCalibrations.data.data;
          let editForm = JSON.parse(sessionStorage.getItem('editForm'));
          if (this.isUpdate() && editForm) {
            this.model.id = editForm.id;
            this.model.businesses_id = editForm.businesses_id;
            this.model.date = moment(editForm.start_date).format('Y-M-D');
            this.model.calibration_type_id = editForm.calibration_type_id;
          }
          setTimeout(() => {
            this.showHideLoading();
          }, 1000);
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },
};
</script>
